module.exports = __webpack_public_path__ + "static/media/cores.be6bc1ef.jpg";